var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlus01Primary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04479 3.08338C8.41298 3.08338 8.71146 3.38186 8.71146 3.75005L8.71146 7.88338H12.8448C13.213 7.88338 13.5115 8.18186 13.5115 8.55005C13.5115 8.91824 13.213 9.21671 12.8448 9.21671H8.71146L8.71146 13.35C8.71146 13.7182 8.41298 14.0167 8.04479 14.0167C7.6766 14.0167 7.37813 13.7182 7.37813 13.35L7.37813 9.21672H3.24479C2.8766 9.21672 2.57812 8.91824 2.57812 8.55005C2.57812 8.18186 2.8766 7.88338 3.24479 7.88338H7.37813L7.37813 3.75005C7.37813 3.38186 7.6766 3.08338 8.04479 3.08338Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus01Primary);
export default __webpack_public_path__ + "static/media/ic-plus-01-primary.deb8d6a7ae05d4c73eb5b61cf408e28c.svg";
export { ForwardRef as ReactComponent };